export const clinicalCareStatus = {
  requested: 'Solicitado',
  revision: 'Em vistoria',
  correction: 'Em correção',
  corrected: 'Corrigido',
  screening: 'Triagem',
  forwarded: 'Encaminhado',
  hospitalized: 'Internado',
  medicalRelease: 'Alta médica',
  death: 'Falecido',
  pullout: 'Em retirada',
  caught: 'Saída',
  done: 'Concluído',
  canceled: 'Cancelado',
  rejected: 'Rejeitado',
  recordAdded: 'Prontuário atualizado',
  priorityChanged: 'Prioridade alterada',
}

export const clinicalCareReportStatuses = [
  'requested',
  'correction',
  'corrected',
  'rejected',
  'screening',
  'forwarded',
  'hospitalized',
  'medicalRelease',
  'death',
  'pullout',
  'caught',
  'done',
  'canceled',
]

export const clinicalCareDateMapLabel = {
  createdAt: 'Data de solicitação',
  forwardedAt: 'Data de encaminhamento',
  scheduledTo: 'Data de agendamento',
  hospitalizedAt: 'Data de internação',
  medicalReleaseAt: 'Data da alta médica',
  pulloutAt: 'Data de retirada',
  caughtAt: 'Data de saída',
  doneAt: 'Data de conclusão',
  canceledAt: 'Data de cancelamento',
  deathAt: 'Data do falecimento',
}

export const clinicalCareStatusClasses = {
  requested: 'text-primary',
  revision: 'text-bold text-warning',
  correction: 'text-bold text-warning',
  corrected: 'text-bold text-primary',
  screening: 'text-bold',
  forwarded: 'text-bold text-primary',
  hospitalized: 'text-bold text-primary',
  medicalRelease: 'text-bold text-success',
  death: 'text-bold text-dark',
  pullout: 'text-bold text-success',
  done: 'text-bold text-success',
  caught: 'text-bold text-success',
  canceled: 'text-bold text-error',
  rejected: 'text-bold text-error',
  priorityChanged: 'text-bold text-warning',
}
